import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { BaseSiteService, ClientTokenService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseSiteConfigService } from '../base-site/base-site-config.service';

@Injectable({
  providedIn: 'root',
})
export class B2bunitService {
  private sessionStorageKey = 'shimanoSessionB2BUnit';
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  activeCart$: Observable<string> = this.cartService.getActiveCartId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url: string;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: UserIdService,
    protected clientToken: ClientTokenService,
    protected baseService: BaseSiteService,
    protected cartService: ActiveCartFacade,
    private baseSiteConfigService: BaseSiteConfigService
  ) {
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => {
      this.url = `${this.occUrl.content}${environment.prefix}${baseSiteData}`;
    });
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get tokenId(): string {
    let tokenId: string;
    this.clientToken
      .getClientToken()
      .pipe(take(1))
      .subscribe((tokenIdData: any) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }

  get activeCartId() {
    let activeCartId: string;
    this.activeCart$.pipe(take(1)).subscribe((activeCart) => (activeCartId = activeCart));
    return activeCartId;
  }

  getShimanoUnitSelectionInfo$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.unit.selection.enabled'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.unit.selection.enabled')
              .map((res: any) => res.value)[0]
        )
      );
  }

  getB2BUnit(): Observable<any> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/management/b2bunit`, {
        headers: this.headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getB2BUnitAddresses(): Observable<any> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/addresses/unitAddresses?fields=FULL`, {
        headers: this.headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getCurrentUserB2BUnits(): Observable<any> {
    return this.http
      .get(`${this.url}/units/${this.userCurrent}/userUnits`, {
        headers: this.headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
